import { Text, useColorModeValue } from "@chakra-ui/react";
import moment from "moment";
import React from "react";

interface DateDisplayProps {
  date: string;
}

function DateDisplay({ date }: DateDisplayProps) {
  const textColor = useColorModeValue("gray.700", "white");
  const formattedDate = moment(date).format("YYYY-MM");

  return (
    <Text fontSize="sm" fontWeight="500" color={textColor}>
      {formattedDate}
    </Text>
  );
}

export default DateDisplay;
